import { useFormStore } from '@/stores/form'
import router from '@/router'
import lookups from '@/assets/json/clientLookups.json'
import axiosInstance from '@/services'
import use124Actions from '@/composables/actions/use124Actions'

import { DateTime } from 'luxon'

async function checkPermitLeaveEligibility() {
  const formStore = useFormStore()

  formStore.form.setValues({
    englishName: null,
    arabicName: null
  })

  const serviceTransactionId = router.currentRoute.value.params.serviceId

  const newDateOfBirth =
    formStore.form.values.dateOfBirth &&
    DateTime.fromFormat(formStore.form.values.dateOfBirth, 'dd/MM/yyyy').toFormat('yyyy/MM/dd')

  const dataObj = {
    fileModuleId: formStore.form.values.fileModuleId,
    fileDepartmentCode: formStore.form.values.departmentCode,
    fileYear: formStore.form.values.serviceYear,
    fileTypeCode: formStore.form.values.serviceCode,
    fileSequance: formStore.form.values.sequenceNumber,
    personUnifiedNumber: formStore.form.values.personUnifiedNumber,
    countryId: formStore.form.values.currentNationalityId,
    dateOfBirth: newDateOfBirth,
    passportNumber: formStore.form.values.passportNumber,
    passportTypeId: formStore.form.values.passportTypeId,
    serviceTransactionId
  }

  try {
    const response = await axiosInstance.post(
      `/api/typingCenter/investigation/check/leavePermit/eligibility`,
      dataObj
    )
    if (response) {
      formStore.extraMap.showPersonalInformation = true
      formStore.extraMap.administrativeRegionId = response.lookupAdminRegionId

      formStore.form.setValues({
        englishName: response.fullNameEnglish,
        arabicName: response.fullNameArabic,
        departmentCode: response.departmentCode,
        serviceYear: response.year,
        serviceCode: response.serviceCode,
        sequenceNumber: response.sequence,
        passportCountryId: response.passportCountryId
      })
      await use124Actions('checkFines')
    }
  } catch (error) {
    console.error('checkInputPersonData error: ', error)
  }
}
export default function (actionName, actionParams) {
  switch (actionName) {
    case 'checkPermitLeaveEligibility':
      checkPermitLeaveEligibility()
      break

    default:
      break
  }
}
